module.exports = __webpack_public_path__ + "static/img/10.732fa2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/10.png
// module id = CYnr
// module chunks = 0